"use client"

import React from "react"
import { useRouter } from "next/navigation"
import { Search } from "../icons/search"
import { Input } from "@/components/ui/input"
import { X } from "lucide-react"

export const HomeMobileSearch = () => {
  const router = useRouter()

  const [term, setTerm] = React.useState("")
  const debounceTimer = React.useRef<NodeJS.Timeout | null>(null)

  const updateSearch = (value: string) => {
    const query = value ? `?q=${encodeURIComponent(value)}` : ""
    router.replace(`/all-products${query}`)
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setTerm(value)

    if (debounceTimer.current) clearTimeout(debounceTimer.current)
    debounceTimer.current = setTimeout(() => {
      updateSearch(value)
    }, 200) // Adjust debounce delay as needed
  }

  const handleClear = () => {
    setTerm("")
    router.replace("/all-products")
  }

  return (
    <div className="flex w-full items-center gap-2 pl-3 my-4 border rounded-md">
      <Search color="#BEBEBE" />
      <Input
        id="search"
        type="text"
        value={term}
        onChange={handleChange}
        placeholder="Search anything"
        className="w-full text-sm font-gilroyRegular border-0 placeholder:text-[#C5C5C5] focus:ring-0 px-0 focus-visible:ring-0 focus-visible:ring-offset-0"
      />
      {term && (
        <X
          className="ml-2 cursor-pointer text-muted"
          size={15}
          onClick={handleClear}
        />
      )}
    </div>
  )
}
